import { gql } from '@apollo/client';

export const GET_STAND_INS = gql(/* GraphQL */ `
    query GetStandIns($historical: Boolean!) {
        getMyStandIns(historical: $historical) {
            id
            start
            end
            primaryUser {
                id
                firstName
                lastName
                designation
                email
                faxNo
                mobileNo {
                    dialingCode
                    countryCode
                    number
                }
                telNo {
                    dialingCode
                    countryCode
                    number
                }
                speedDial
                designation
            }
            substituteUser {
                id
                firstName
                lastName
                designation
                email
                faxNo
                mobileNo {
                    dialingCode
                    countryCode
                    number
                }
                telNo {
                    dialingCode
                    countryCode
                    number
                }
                speedDial
                designation
            }
        }
    }
`);

export const GET_STAND_IN_STATUS = gql(/* GraphQL */ `
    query GetStandInStatus {
        getCurrentUserStandInStatus {
            isStandingIn
            myStandIn {
                id
                start
                end
                substituteUser {
                    id
                    firstName
                    lastName
                }
            }
            standInsFor {
                id
                start
                end
                primaryUser {
                    id
                    firstName
                    lastName
                }
            }
        }
    }
`);

export const GET_STAND_IN_GANTT_DATA = gql(/* GraphQL */ `
    query GetStandInGanttData($startDate: String!, $endDate: String!) {
        getStandInGanttData(startDate: $startDate, endDate: $endDate) {
            firstName
            lastName
            primaryUserId
            standIns {
                start
                end
                substituteFirstName
                substituteLastName
                substituteId
            }
        }
    }
`);
